<template>
  <v-row></v-row>
</template>

<script>
import constant from "../../../const";
export default {
  components: {},
  props: ["value"],
  data() {
    return {};
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {},
};
</script>

<style scoped></style>
